// zod schemas for data files (CLAUDE.md → Data-driven content).
// M1 validates the `map` portion of level files strictly. The rest of a level is
// accepted as-is for now; M3–M5 tighten it (units, orders, win conditions).
import { z } from 'zod';

const offset = z.tuple([z.number().int(), z.number().int()]);

/** One hex token: cover letter + elevation digit, e.g. "w3". */
export const HEX_TOKEN = /^[owus~][0-9]$/;

export const mapSchema = z.strictObject({
  width: z.number().int().min(1).max(40),
  height: z.number().int().min(1).max(28),
  /** One string per row, top to bottom, tokens separated by single spaces. */
  rows: z.array(z.string()),
  edges: z.array(
    z.strictObject({
      a: offset,
      b: offset,
      kind: z.enum(['road', 'river', 'stream', 'bridge']),
    }),
  ),
  obstacles: z.array(
    z.strictObject({
      hex: offset,
      kind: z.enum(['minefield', 'wire']),
    }),
  ),
});

export const levelSchema = z.looseObject({
  id: z.string().regex(/^[a-z0-9-]+$/),
  schema: z.literal(1),
  title: z.string().min(1),
  map: mapSchema,
});

export type LevelFileMap = z.infer<typeof mapSchema>;
export type LevelFile = z.infer<typeof levelSchema>;
